module.exports = __webpack_public_path__ + "img/app_logo.a0018917.svg";